import React from "react";
import { Imgs } from "../../img/Imgs/Imgs";

const NotFound = () => {
  return (
    <section className="notFound">
      <div className="notFound__container container">
        <div className="notFound__left-box">
            <p>error 404</p>
            <span>Page Not Found</span>
            <img src={Imgs.robotimg} alt="" />
        </div>
        <div className="notFound__right-box">
          <img src={Imgs.oopsImg} alt="" />
          <img src={Imgs.errorImg} alt="" />
        </div>
      </div>
    </section>
  );
}; 

export default NotFound;
